import { Description, Foundation, LocationOn } from '@mui/icons-material';
import { Box, Button, IconButton, Paper, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface IToolsDashbordProps {
    showNewButton?: boolean;
    showLocalizationButton?: boolean;
    showDataButton?: boolean;
}

export const ToolsDashbord: React.FC<IToolsDashbordProps> = ({
    showNewButton = true,
    showLocalizationButton = true,
    showDataButton = true,
}) => {
    const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();

    const [activeRoute, setActiveRoute] = useState<string>('');

    useEffect(() => {
        setActiveRoute(location.pathname);
    }, [location.pathname]);

    const handleNavigation = (path: string) => {
        navigate(path);
        setActiveRoute(path);
    };

    const isActive = (path: string) => activeRoute === path;

    return (
        <Box
            component={Paper}
            height={theme.spacing(4)}
            marginX={1}
            paddingX={2}
            padding={1}
            display={'flex'}
            gap={2}
            alignItems={'center'}
            borderRadius={2}
            justifyContent={smDown ? 'space-between' : 'start'}
        >
            {(showNewButton) && (
                <>
                    {smDown ? (
                        <IconButton
                            onClick={() => handleNavigation('/home')}
                            color={isActive('/home') ? 'primary' : 'default'}
                        >
                            <Foundation />
                        </IconButton>
                    ) : (
                        <Button
                            variant={isActive('/home') ? 'contained' : 'outlined'}
                            disableElevation
                            onClick={() => handleNavigation('/home')}
                            startIcon={<Foundation color={isActive('/home') ? 'inherit' : 'primary'} />}
                            sx={{ borderRadius: '25px' }}
                        >
                            <Typography
                                variant='button'
                                whiteSpace={'nowrap'}
                                textOverflow={'ellipsis'}
                                overflow={'hidden'}
                            >
                                ESTRUTURAS
                            </Typography>
                        </Button>
                    )}
                </>
            )}

            {(showLocalizationButton) && (
                <>
                    {smDown ? (
                        <IconButton
                            onClick={() => handleNavigation('/locations')}
                            color={isActive('/locations') ? 'primary' : 'default'}
                        >
                            <LocationOn />
                        </IconButton>
                    ) : (
                        <Button
                            variant={isActive('/locations') ? 'contained' : 'outlined'}
                            disableElevation
                            onClick={() => handleNavigation('/locations')}
                            startIcon={<LocationOn color={isActive('/locations') ? 'inherit' : 'primary'} />}
                            sx={{ borderRadius: '25px' }}
                        >
                            <Typography
                                variant='button'
                                whiteSpace={'nowrap'}
                                textOverflow={'ellipsis'}
                                overflow={'hidden'}
                            >
                                LOCALIZAÇÃO DAS ESTRUTURAS
                            </Typography>
                        </Button>
                    )}
                </>
            )}

            {(showDataButton) && (
                <>
                    {smDown ? (
                        <IconButton
                            onClick={() => handleNavigation('/consolidated')}
                            color={isActive('/consolidated') ? 'primary' : 'default'}
                        >
                            <Description />
                        </IconButton>
                    ) : (
                        <Button
                            variant={isActive('/consolidated') ? 'contained' : 'outlined'}
                            disableElevation
                            onClick={() => handleNavigation('/consolidated')}
                            startIcon={<Description color={isActive('/consolidated') ? 'inherit' : 'primary'} />}
                            sx={{ borderRadius: '25px' }}
                        >
                            <Typography
                                variant='button'
                                whiteSpace={'nowrap'}
                                textOverflow={'ellipsis'}
                                overflow={'hidden'}
                            >
                                DADOS CONSOLIDADOS
                            </Typography>
                        </Button>
                    )}
                </>
            )}
        </Box>
    );
};